module.exports = __webpack_public_path__ + "static/media/ugx.static.89795da9.svg";